import React from 'react';
import pulse from '@finn-no/pulse-sdk';
import TopBar from './topbar';
import { TrackerData } from '@finn-no/pulse-sdk/dist/types';
import { Profile } from '@finn-no/profile-client';
import { Organisation } from '@finn-no/organisation-http-client';

function trackEvent(analyticsNameDetail: string) {
    if (analyticsNameDetail === 'profile-click') {
        const pulsePayload: TrackerData = {
            type: 'View',
            object: {
                type: 'UserProfilePage',
                pageType: 'company_profile',
            },
            vertical: {
                name: 'common_pages',
                subVertical: 'b2b_admin',
            },
        };
        pulse.trackEvent(pulsePayload);
    }
}

export type TopBarWithoutTrackingProps = {
    organisations?: Organisation[];
    profile?: Profile;
    isCompanyProfileOnJobUnleashEnabled?: boolean;
    isCompanyProfileOnMotorUnleashEnabled?: boolean;
    hideMenu?: boolean;
    accountMenuOpen?: boolean;
    isMobilityPriceoverviewRedirectUnleashEnabled?: boolean;
};

export default function TopBarWithTracking(props: TopBarWithoutTrackingProps) {
    return <TopBar {...props} track={trackEvent} />;
}
